import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded'
import { Box, ButtonBase, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslate } from 'react-admin'
import { useNavigate } from 'react-router-dom'
import { border } from '../../layout/theme/border'
import { fadeSlideIn } from './animations'

export const PendingBanner: FC<{
  count: number;
  messageKey: string;
  href: string;
  accent: string;
  accentBg: string;
  delay: number;
}> = ({ count, messageKey, href, accent, accentBg, delay }) => {
  const translate = useTranslate()
  const navigate = useNavigate()
  if (!count) return null
  return (
    <ButtonBase
      onClick={() => navigate(href)}
      sx={{
        'display': 'flex',
        'alignItems': 'center',
        'gap': 1.5,
        'width': '100%',
        'px': 2.5,
        'py': 1.5,
        'borderRadius': border.card.radius,
        'border': '1px solid',
        'borderColor': accentBg,
        'background': '#fff',
        'textAlign': 'left',
        'animation': `${fadeSlideIn} 0.4s ease-out ${delay}ms both`,
        'transition': 'border-color 0.15s, box-shadow 0.15s',
        '&:hover': {
          borderColor: accent,
          boxShadow: `0 0 0 1px ${accent}`,
        },
      }}
    >
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: border.radius.sm,
          bgcolor: accentBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Typography sx={{ fontSize: 15, fontWeight: 700, color: accent, lineHeight: 1 }}>
          {count}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontSize: 13,
          fontWeight: 500,
          color: '#1a1a1a',
          flex: 1,
        }}
      >
        {translate(messageKey, { count })}
      </Typography>
      <ArrowForwardRoundedIcon sx={{ fontSize: 18, color: accent, flexShrink: 0 }} />
    </ButtonBase>
  )
}
